<template>
  <div class="body_div">
    <div
      v-for="item in specMaterialList"
      :key="item.amzSkuMaterialCode"
      class="fabric-info__container"
    >
      <div class="fabric-img__wrapper">
        <el-image
          :src="
            item.defaultImageUrl
              ? $osscdn(item.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          :preview-src-list="[
            item.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          class="fabric-img"
        >
          <div slot="error" class="image-slot">
            <img src="/image/static/img/nopic.jpg" class="fabric-img" />
          </div>
        </el-image>
        <div class="ml-2">
          <div class="span_class">
            <el-tooltip
              class=""
              effect="dark"
              :content="item.specName"
              :disabled="isShowTooltip"
              placement="top"
            >
              <span
                :ref="item.specName + item.specNo"
                @mouseover="
                  onMouseOver(item.specName + item.specNo)
                "
                >{{ item.specName }}</span
              >
            </el-tooltip>
          </div>
          <div class="span_class">
            <el-tooltip
              class=""
              effect="dark"
              :content="item.specNameEn"
              :disabled="isShowTooltip"
              placement="top"
            >
              <span
                :ref="item.specNameEn + item.specNo"
                @mouseover="onMouseOver(item.specNameEn + item.specNo)"
                >{{ item.specNameEn }}</span
              >
            </el-tooltip>
          </div>
          <div class="span_class">
            <span>{{ item.specNo }}</span>
          </div>
          <div class="div_flex">
            <div>
              <span
                >{{ $l('INDEX.amz_sku_label_specQty') || '规格数量' }}：{{
                  item.specQty
                }}</span
              >
            </div>
            <div>
              <span> {{ $l('INDEX.amz_sku_label_useQty') || '用量' }}：</span>
              <span class="span_text"> {{ item.materialUseQty }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    specMaterialList: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: true },
  },
  components: {},
  mixins: [],
  data() {
    return { isShowTooltip: false }
  },
  watch: {},
  methods: {
    onMouseOver(event) {
      const tag = this.$refs[event]
      const parentWidth = tag[0].parentNode.offsetWidth
      const contentWidth = tag[0].offsetWidth
      this.isShowTooltip = contentWidth <= parentWidth
    },
  },
}
</script>
<style lang="scss" scoped>
.body_div {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.span_class {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 230px;
}

.fabric-info__container {
  width: 310px;
  height: 94px;
  border-radius: 5px;
  background-color: #f4f6f9;
  color: #101010;
  padding: 5px;
  margin-right: 10px;

  .fabric-img__wrapper {
    display: flex;
    justify-content: flex-start;
    .fabric-img {
      width: 60px;
      min-width: 60px;
      height: 60px;
      min-height: 60px;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      margin-bottom: 15px;
      > img {
        width: 60px;
        min-width: 60px;
        height: 60px;
        min-height: 60px;
        border-radius: 3px;
      }
    }
    > img {
      width: 96px;
      height: 96px;
      border-radius: 3px;
    }
    > div {
      .div_flex {
        display: flex;
        justify-content: space-between;
        width: 200px;
      }
      > div {
        > span {
          color: #101010;
          font-size: 14px;
        }
        .span_text {
          font-size: 18px;
          height: 10px;
          line-height: 19px;
          font-weight: 700;
        }
      }
    }
  }
}
</style>
